import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getEvents = async () => {
  const { data } = await axios.get(`${API}/events`);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await axios.post(`${API}/newsletter`, { email });
  return data;
};

export const hostJam = async (payload) => {
  const { data } = await axios.post(`${API}/host-jam`, payload);
  return data;
};
